/* Crafted by Chitra — Amazon-style storefront. No dependencies. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ drawer */
  var scrim = $('[data-scrim]');
  var drawer = $('#nav-drawer');

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-open'); scrim.hidden = true; }
    document.body.style.overflow = '';
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
    var f = drawer.querySelector('a,button');
    if (f) f.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-drawer]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawer(); }
  });
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ----------------------------------------------------------- gallery */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    if (!main) return;
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) { main.src = full; main.removeAttribute('srcset'); }
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  function showMedia(mediaId, imageUrl) {
    var main = $('[data-gallery-main]');
    if (!main) return;
    var thumb = mediaId && $('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) { thumb.click(); thumb.scrollIntoView({ block: 'nearest', inline: 'center' }); }
    else if (imageUrl) { main.src = imageUrl; main.removeAttribute('srcset'); }
  }

  /* ---------------------------------------------------------- quantity */
  function inr(cents) {
    var n = Math.round(cents / 100), s = String(n);
    var last3 = s.slice(-3), rest = s.slice(0, -3);
    return '₹' + (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3 : last3);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    e.preventDefault();
    var input = $('input', b.parentNode);
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var val = parseInt(input.value || min, 10) + (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    val = Math.max(min, val);
    input.value = val;

    // On the cart page the number alone means nothing - push it to the cart and
    // refresh the totals, otherwise the page and the checkout disagree.
    var line = b.closest('[data-line]');
    if (line) updateLine(line, val, b);
  });

  function updateLine(line, qty, btn) {
    var row = line.closest('[data-line]') || line;
    var siblings = $$('[data-qty]', row);
    siblings.forEach(function (x) { x.disabled = true; });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(row.getAttribute('data-line'), 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (qty === 0) { window.location.reload(); return; }
        var item = cart.items[parseInt(row.getAttribute('data-line'), 10) - 1];
        var lp = $('[data-line-price]', row);
        if (item && lp) lp.textContent = inr(item.final_line_price);
        $$('[data-cart-total]').forEach(function (el) { el.textContent = inr(cart.total_price); });
        $$('[data-cart-qty]').forEach(function (el) { el.textContent = cart.item_count; });
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { siblings.forEach(function (x) { x.disabled = false; }); });
  }

  // typing a quantity directly should behave the same way
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line] input[name="updates[]"]');
    if (!input) return;
    var line = input.closest('[data-line]');
    updateLine(line, Math.max(0, parseInt(input.value || '0', 10)), null);
  });

  /* ----------------------------------------------------- variant picker */
  $$('[data-variants]').forEach(function (root) {
    var holder = $('[data-variant-json]', root);
    if (!holder) return;
    var data;
    try { data = JSON.parse(holder.textContent); } catch (err) { return; }

    var idField = $('[data-variant-id]', root);
    var stockEl = $('[data-variant-stock]', root);
    var addBtn  = $('[data-add-button]', root);
    var money   = root.getAttribute('data-money-format') || '₹{{amount}}';

    function group(n) {
      var s = String(n), last3 = s.slice(-3), rest = s.slice(0, -3);
      if (!rest) return last3;
      return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    }

    function render(cents) {
      if (cents === 0) return '<span class="price-unset">Price on request</span>';
      return '<span class="amt">₹' + group(Math.round(cents / 100)) + '</span>';
    }

    function chosen() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) {
          return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
        })
        .map(function (i) { return i.value; });
    }

    function update() {
      var sel = chosen();
      var match = data.filter(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      })[0];

      // reflect the chosen value in each option label
      $$('[data-option-index]', root).forEach(function (i) {
        if (!i.checked) return;
        var pos = parseInt(i.getAttribute('data-option-index'), 10) + 1;
        var out = $('[data-opt-current="' + pos + '"]', root);
        if (out) out.textContent = i.value;
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      if (idField) idField.value = match.id;

      $$('[data-variant-price]').forEach(function (el) { el.innerHTML = render(match.price); });

      if (stockEl) {
        stockEl.className = 'row__stock' + (match.available ? '' : ' row__stock--out');
        stockEl.textContent = match.available
          ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out');
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-soldout');
      }
      showMedia(match.media_id, match.image);

      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u.toString());
      }
    }

    $$('[data-option-index]', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  /* --------------------------------------------------------- add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-add-button]', form);
    var original = btn ? btn.textContent : '';
    var buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || 'Adding...'; }

    var qtyEl = $('[name="quantity"]', form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt($('[data-variant-id]', form).value, 10),
          quantity: parseInt(qtyEl ? qtyEl.value : 1, 10) || 1
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (buyNow) { window.location.href = '/checkout'; return null; }
        return refreshCount();
      })
      .then(function (cart) {
        if (cart && btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = original; }, 1600); }
      })
      .catch(function (err) { alert(err.message || 'Could not add this item.'); if (btn) btn.textContent = original; })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  function refreshCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    });
  }

  /* back-to-top: only show it once there is something to scroll back from */
  var totop = document.querySelector('.totop');
  if (totop) {
    var toggleTop = function () { totop.classList.toggle('is-on', window.scrollY > 600); };
    window.addEventListener('scroll', toggleTop, { passive: true });
    toggleTop();
    totop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* the sticky phone bar just proxies the real add button */
  var sticky = $('[data-sticky-add]');
  if (sticky) {
    sticky.addEventListener('click', function () {
      var real = $('[data-add-button]');
      if (real) real.click();
    });
  }
})();
